<template>
    <headroom :disabled="disabled" @mouseenter="disabled = true" @mouseleave="disabled = false" @pin="handlePin">
        <slot></slot>
    </headroom>
</template>

<script>
    import { headroom } from 'vue-headroom';

    export default {
        name: "HeadroomWrapper",

        components: {
            headroom
        },

        data() {
            return {
                disabled: false
            }
        },

        computed: {
            onOccasionDetailPage() {
                return document.querySelector('body').classList.contains('path-occasion');
            }
        },

        methods: {
            handlePin() {
                if ( ! this.onOccasionDetailPage) {
                    return;
                }

                this.disabled = true;
            }
        }
    }
</script>
